import {
    SET_NEW_BOOKING_START_DATE,
    SET_NEW_BOOKING_START_TIME,
    SET_NEW_BOOKING_END_TIME,
    SET_NEW_BOOKING_PICKUP_LOCATION,
    SET_NEW_BOOKING_JOURNEY_TO_LOCATION,
    SET_NEW_BOOKING_CUSTOM_JOURNEY_TO_LOCATION,
    SET_NEW_BOOKING_TRAVEL_REASON,
    SET_NEW_BOOKING_CUSTOM_TRAVEL_REASON,
    SET_NEW_BOOKING_COST_CENTRE,
    SET_NEW_BOOKING_PLANT,
    SET_NEW_BOOKING_PLANT_TYPE,
    FETCH_AVAILABLE_PLANT,
    FETCH_AVAILABLE_PLANT_TYPES,
    SET_AVAILABLE_PLANT,
    SET_NEW_BOOKING_PRIVATE_USE,
    SET_NEW_BOOKING_INITIAL_STATE,
    CREATE_BOOKING,
} from '../constants';

export const setNewBookingStartDate = (startDate) => {
    return {
        type: SET_NEW_BOOKING_START_DATE,
        startDate
    };
};

export const setNewBookingStartTime = (startTime) => {
    return {
        type: SET_NEW_BOOKING_START_TIME,
        startTime,
    };
};

export const setNewBookingEndTime = (endTime) => {
    return {
        type: SET_NEW_BOOKING_END_TIME,
        endTime,
    };
};

export const setNewBookingPickupLocation = (locationId) => {
    return {
        type: SET_NEW_BOOKING_PICKUP_LOCATION,
        locationId,
    };
};

export const setNewBookingJourneyToLocation = (locationId) => {
    return {
        type: SET_NEW_BOOKING_JOURNEY_TO_LOCATION,
        locationId,
    };
};

export const setNewBookingCustomJourneyToLocation = (journeyToLocation) => {
    return {
        type: SET_NEW_BOOKING_CUSTOM_JOURNEY_TO_LOCATION,
        journeyToLocation,
    };
};

export const setNewBookingTravelReason = (travelReasonId) => {
    return {
        type: SET_NEW_BOOKING_TRAVEL_REASON,
        travelReasonId,
    };
};

export const setNewBookingCustomTravelReason = (travelReason) => {
    return {
        type: SET_NEW_BOOKING_CUSTOM_TRAVEL_REASON,
        travelReason,
    };
};

export const setNewBookingCostCentre = (costCentreId) => {
    return {
        type: SET_NEW_BOOKING_COST_CENTRE,
        costCentreId,
    };
};

export const setNewBookingPlant = (plantId) => {
    return {
        type: SET_NEW_BOOKING_PLANT,
        plantId,
    };
};

export const setNewBookingPlantType = (plantTypeId, plantType) => {
    return {
        type: SET_NEW_BOOKING_PLANT_TYPE,
        plantTypeId,
        plantType,
    };
};

export const setNewBookingPrivateUse = (privateUse) => {
    return {
        type: SET_NEW_BOOKING_PRIVATE_USE,
        privateUse,
    };
};

export const fetchAvailablePlant = (startTime, endTime, plantTypeId, driverId, locationId) => {
    return {
        type: FETCH_AVAILABLE_PLANT,
        startTime,
        endTime,
        plantTypeId,
        driverId,
        locationId,
    };
};

export const fetchAvailablePlantTypes = (availablePlantTypeIds) => {
    return {
        type: FETCH_AVAILABLE_PLANT_TYPES,
        availablePlantTypeIds
    };
};

export const setAvailablePlant = (plantIds) => {
    return {
        type: SET_AVAILABLE_PLANT,
        plantIds,
    };
};

export const setNewBookingInitialState = () => {
    return {
        type: SET_NEW_BOOKING_INITIAL_STATE,
    };
};

export const createBooking = () => {
    return {
        type: CREATE_BOOKING,
    };
};


// WEBPACK FOOTER //
// ./scripts/actions/newBooking.js